import { render, staticRenderFns } from "./PublicForm.vue?vue&type=template&id=4cbfbce1&scoped=true&"
import script from "./PublicForm.vue?vue&type=script&lang=ts&"
export * from "./PublicForm.vue?vue&type=script&lang=ts&"
import style0 from "./PublicForm.vue?vue&type=style&index=0&id=4cbfbce1&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbfbce1",
  null
  
)

export default component.exports